var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"font-family-gilroy"},[_c('div',{staticClass:"desktop-main"},[(_vm.showNavbar)?_c('app-menu'):_vm._e(),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }